module.exports = __webpack_public_path__ + "img/storagehouse64_ua.1f952055.webp";